/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Your_TeamsInputs */

const th_your_teams = /** @type {(inputs: Your_TeamsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ทีมของคุณ`)
};

const en_your_teams = /** @type {(inputs: Your_TeamsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your teams`)
};

const ja_your_teams = /** @type {(inputs: Your_TeamsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`あなたのチーム`)
};

const zh_your_teams = /** @type {(inputs: Your_TeamsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`你的球队`)
};

const es_your_teams = /** @type {(inputs: Your_TeamsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tus equipos`)
};

const pt_your_teams = /** @type {(inputs: Your_TeamsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seus times`)
};

const id_your_teams = /** @type {(inputs: Your_TeamsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tim Anda`)
};

const fr_your_teams = /** @type {(inputs: Your_TeamsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vos équipes`)
};

const tl_your_teams = /** @type {(inputs: Your_TeamsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ang mga team mo`)
};

const vi_your_teams = /** @type {(inputs: Your_TeamsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đội của bạn`)
};

const ko_your_teams = /** @type {(inputs: Your_TeamsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`내 팀`)
};

const de_your_teams = /** @type {(inputs: Your_TeamsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deine Teams`)
};

const ru_your_teams = /** @type {(inputs: Your_TeamsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ваши команды`)
};

const tr_your_teams = /** @type {(inputs: Your_TeamsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Takımlarınız`)
};

const it_your_teams = /** @type {(inputs: Your_TeamsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Le tue squadre`)
};

const pl_your_teams = /** @type {(inputs: Your_TeamsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Twoje drużyny`)
};

const uk_your_teams = /** @type {(inputs: Your_TeamsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ваші команди`)
};

const hi_your_teams = /** @type {(inputs: Your_TeamsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`आपकी टीमें`)
};

const ar_your_teams = /** @type {(inputs: Your_TeamsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`فرقك`)
};

const ms_your_teams = /** @type {(inputs: Your_TeamsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pasukan anda`)
};

const bn_your_teams = /** @type {(inputs: Your_TeamsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`আপনার দল`)
};

const zh_tw2_your_teams = /** @type {(inputs: Your_TeamsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`你的球隊`)
};

const zh_hk2_your_teams = /** @type {(inputs: Your_TeamsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`你的球隊`)
};

const ur_your_teams = /** @type {(inputs: Your_TeamsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`آپ کی ٹیمیں`)
};

const fa_your_teams = /** @type {(inputs: Your_TeamsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تیم‌های شما`)
};

const sw_your_teams = /** @type {(inputs: Your_TeamsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Timu zako`)
};

const nl_your_teams = /** @type {(inputs: Your_TeamsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jouw teams`)
};

/**
* | output |
* | --- |
* | "Your teams" |
*
* @param {Your_TeamsInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const your_teams = /** @type {((inputs?: Your_TeamsInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Your_TeamsInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_your_teams(inputs)
	if (locale === "ja") return ja_your_teams(inputs)
	if (locale === "zh") return zh_your_teams(inputs)
	if (locale === "es") return es_your_teams(inputs)
	if (locale === "pt") return pt_your_teams(inputs)
	if (locale === "id") return id_your_teams(inputs)
	if (locale === "fr") return fr_your_teams(inputs)
	if (locale === "tl") return tl_your_teams(inputs)
	if (locale === "vi") return vi_your_teams(inputs)
	if (locale === "ko") return ko_your_teams(inputs)
	if (locale === "de") return de_your_teams(inputs)
	if (locale === "ru") return ru_your_teams(inputs)
	if (locale === "tr") return tr_your_teams(inputs)
	if (locale === "it") return it_your_teams(inputs)
	if (locale === "pl") return pl_your_teams(inputs)
	if (locale === "uk") return uk_your_teams(inputs)
	if (locale === "hi") return hi_your_teams(inputs)
	if (locale === "ar") return ar_your_teams(inputs)
	if (locale === "ms") return ms_your_teams(inputs)
	if (locale === "bn") return bn_your_teams(inputs)
	if (locale === "zh-TW") return zh_tw2_your_teams(inputs)
	if (locale === "zh-HK") return zh_hk2_your_teams(inputs)
	if (locale === "ur") return ur_your_teams(inputs)
	if (locale === "fa") return fa_your_teams(inputs)
	if (locale === "sw") return sw_your_teams(inputs)
	if (locale === "nl") return nl_your_teams(inputs)
	return en_your_teams(inputs)
});